<template>
  <v-card>
    <div class="pa-4">
      <div class="d-flex justify-space-between align-center">
        <h3 class="text">Thông tin cơ bản</h3>
        <v-btn
          v-if="!item.isOpenRegister && $auth.policies['update-club']"
          outlined
          color="#0D47A1"
          @click="$refs.clubDialog.openDialog('update', item)"
        >
          Sửa
        </v-btn>
      </div>
      <div class="mt-2">
        <div class="d-flex">
          <div class="text title-info">Tiêu đề</div>
          <div class="text">{{ item.name }}</div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Mô tả</div>
          <div class="text" style="white-space: pre-line">
            {{ item.description }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Ngày tạo</div>
          <div class="text">
            {{ item.createdAt | ddmmyyyy }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái hiển thị</div>
          <div class="text">
            <v-chip :color="item.published | getColorClubPublished" small class="white--text">{{
              item.published | getTextClubPublished
            }}</v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái đăng ký</div>
          <div class="text">
            <v-chip :color="item.isOpenRegister | getColorClubOpenRegister" small class="white--text">{{
              item.isOpenRegister | getTextClubOpenRegister
            }}</v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Áp dụng</div>
          <div class="text">
            <v-chip class="mr-2" v-for="(item, index) in listTargets" :key="index">
              {{ item.title || '' }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Số lượng tham gia</div>
          <div class="text">{{ item.countMembers || 0 }} / {{ item.maxMembers }}</div>
        </div>
      </div>
    </div>
    <ClubDialog ref="clubDialog" />
  </v-card>
</template>

<script>
import ClubDialog from '../club/ClubDialog.vue'
import { mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: {
    ClubDialog
  },
  computed: {
    ...mapState({
      item: state => state.club.item
    }),
    listTargets() {
      if (this.item.applyFor === 'all') return [{ title: 'Toàn trường' }]
      if (this.item.applyFor === 'specific') return [{ title: `${this.item.students.length} học sinh` }]
      return [
        ...get(this, 'item.grades', []),
        ...get(this, 'item.classes', []),
        ...get(this, 'item.academicLevels', [])
      ]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.title-info {
  min-width: 170px;
}
</style>
